import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import { FaEye, FaRegCircleUser } from 'react-icons/fa6';
import { useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import ROLE from '../common/role';
import { CiTimer } from 'react-icons/ci';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';

const OrderPage = () => {
  const [data, setData] = useState([]);
  const [cosmeticData, setCosmeticData] = useState([]);
  const [error, setError] = useState(null);
  const [cosmeticError, setCosmeticError] = useState(null);
  const [loading, setLoading] = useState(true); 
  const user = useSelector(state => state?.user?.user);
  const location = useLocation();
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };



  useEffect(() => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => {
      setLoading(false);
      navigate("/");
    }, 10000);

    if (user) {
      if (user?.role !== ROLE.GENERAL) {
        navigate("/");
        setLoading(false);
      } else {
        setLoading(false);
        clearTimeout(loadingTimeout);
        fetchMedicineOrderDetails();
        fetchCosmeticOrderDetails();
      }
    }

    return () => clearTimeout(loadingTimeout);
  }, [user, navigate,startDate, endDate]);

  const fetchMedicineOrderDetails = async () => {
    try {

      const body = {
        
        startDate: startDate ? moment(startDate).toISOString() : '',
        endDate: endDate ? moment(endDate).toISOString() : ''
      };

      const response = await fetch(SummaryApi.getOrder.url, {
        method: SummaryApi.getOrder.method,
        credentials: 'include',
        headers: {
          "Content-Type": 'application/json'
        },
        body: JSON.stringify(body)
      });
      const responseData = await response.json();
      if (responseData.success) {
        setData(responseData.data || []);
      } else {
        setError(responseData.message);
        setData([]);
      }
    } catch (error) {
      setError('Error fetching payment history');
      setData([]);
    }
  };

  const fetchCosmeticOrderDetails = async () => {
    try {
      const body = {
        
        startDate: startDate ? moment(startDate).toISOString() : '',
        endDate: endDate ? moment(endDate).toISOString() : ''
      };

      const response = await fetch(SummaryApi.orderCosmeticController.url, {
        method: SummaryApi.orderCosmeticController.method,
        credentials: 'include',
        headers: {
          "Content-Type": 'application/json'
        },
        body: JSON.stringify(body)
      });
      const responseData = await response.json();
      if (responseData.success) {
        setCosmeticData(responseData.data || []);
      } else {
        setCosmeticError(responseData.message);
        setCosmeticData([]);
      }
    } catch (cosmeticError) {
      setCosmeticError('Error fetching payment history');
      setCosmeticData([]);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'accepted':
        return 'bg-blue-900 text-white';
      case 'done':
        return 'bg-green-700 text-white';
      case 'pending':
        return 'bg-yellow-600 text-white';
      case 'rejected':
        return 'bg-red-800 text-white';
        case 'refused':
          return 'bg-red-900 text-white';
      default:
        return 'bg-gray-700 text-white';
    }
  };


  const mergedData = [
    ...data?.map(item => ({ ...item, paymentSource: 'شركة دواكو' })),
    ...cosmeticData?.map(item => ({ ...item, paymentSource: 'شركة مستحضرات التجميل' }))
  ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));


  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
    );
  }

  const handleViewOrder = (orderId, type) => {
    navigate(`/userViewOrderDetails/${orderId}/${type}`);
};

  

  return (
    <div className="min-h-[calc(100vh-120px)] lg:flex">
      
       {/* Mobile Toggle Button */}
       <button onClick={toggleSidebar} className="lg:hidden fixed top-20 left-4 z-50 bg-blue-900 text-white p-2 rounded-full">
        {isSidebarOpen ? <AiOutlineClose size={18} /> : <AiOutlineMenu size={18} />}
      </button>
      {/* Sidebar */}
      <aside className={`lg:block w-full max-w-60 customShadow transition-transform duration-300 ease-in-out
                  ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
                  fixed lg:relative z-10 bg-white lg:bg-transparent lg:translate-x-0 h-full lg:h-auto top-18`}>
  <div className='h-32 flex justify-center items-center flex-col'>
    <div className='text-5xl cursor-pointer relative flex justify-center'>
      {user?.profilePic ? (
        <img src={user?.profilePic} className='w-20 h-20 rounded-full' alt={user?.name} />
      ) : (
        <FaRegCircleUser />
      )}
    </div>
    <p className='capitalize text-lg font-semibold'>{user?.name}</p>
    <p className='text-sm'>{user?.pharmacistOrPharmacy === 'pharmacy' ? 'صيدلية' : user?.pharmacistOrPharmacy === 'pharmacist' ? 'عميل' : user?.pharmacistOrPharmacy}</p>
  </div>

  {/* Navigation */}
  <div>
    <nav className='grid p-4'>

      {/* معلومات شخصية */}
      {/*
      <div className='mb-4'>
        <h3 className='text-lg font-bold mb-2'>معلومات شخصية</h3>
        <Link
          to='/userProfile'
          className={`block px-2 py-1 ${location.pathname === '/userProfile' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'}`}
        >
          الملف الشخصي
        </Link>
        <Link
          to='/userEditProfile'
          className={`block px-2 py-1 ${location.pathname === '/userEditProfile' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'}`}
        >
          تعديل الملف الشخصي
        </Link>
        <Link
          to='/changePassword'
          className={`block px-2 py-1 ${location.pathname === '/changePassword' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'}`}
        >
          تغيير كلمة المرور
        </Link>
      </div>
*/}
      {/* معلومات الموقع */}
      <div >
        <h3 className='text-xl font-bold mb-2 text-center'>ادارة شئون الحساب</h3>
        <Link
          to='/order-history'
          className={`block px-2 py-1 ${location.pathname === '/order-history' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          جميع الطلبات
        </Link>
        {user?.pharmacistOrPharmacy === 'pharmacy' && (
          <>
            <Link
              to='/PaymentHistory'
              className={`block px-2 py-1 ${location.pathname === '/PaymentHistory' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
            >
              (المديونية) سجل المدفوعات
            </Link>
            <Link
              to='/userPaymentAndOrdersHistory'
              className={`block px-2 py-1 ${location.pathname === '/userPaymentAndOrdersHistory' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
            >
              سجل حسابات دواكو
            </Link>
            

            <Link
              to='/userRefundRequests'
              className={`block px-2 py-1 ${location.pathname === '/userRefundRequests' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
            >
              طلبات الاسترجاع
            </Link>
          </>
        )}
      </div>
    </nav>
  </div>
</aside>



      {/* Main content */}
      <main className={`w-full h-full p-2 ${isSidebarOpen ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>

         {/* Date Filter Section */}
         <div className="flex justify-end items-start mb-4">
                    <div className="text-right">
                      <h2 className="text-xl font-bold mb-6">حدد المدة التي تريد ان تري بها الفواتير </h2>

                      <div className="flex gap-6 justify-end">
                        {/* Start Date */}
                        <div>
                          <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
                            تاريخ البداية
                          </label>
                          <input
                            type="date"
                            id="startDate"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                          />
                        </div>

                        {/* End Date */}
                        <div>
                          <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
                            تاريخ النهاية
                          </label>
                          <input
                            type="date"
                            id="endDate"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
        
        {error ? (
          <p>{error}</p>
        ) : mergedData.length === 0 ? (
          <p>لا يوجد طلبات سابقة</p>
        ) : (
          <>  
           

            {mergedData.length === 0 ? (
              <p>لا يوجد طلبات حاليا</p>
            ) : (
              <div className='overflow-x-auto'>
                <table className='w-full border-collapse border border-gray-300'>
                  <thead>
                    <tr className='bg-black text-white'>
                    <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">كود الطلب[المرتجع]</th>
                    <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">تم  بواسطة</th>
                      <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">اسم مندوب المبيعات</th>
                     {/* <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">البريد الالكتروني مندوب المبيعات</th>*/}
                   {/*  <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">اسم الشركة</th>* */} 
                      <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">تاريخ الطلب</th>
                      <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">السعر الاجمالى</th>
                      <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">حالة الطلب</th>
                      <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">تفاصيل الطلب</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {mergedData.map((item, index) => (
                      <tr key={item._id || index} className="min-h-[80px] border-t border-gray-300">
                      {item.type==='order'&& <td className="text-center py-2 px-4 border border-gray-300">#{item.orderCode}</td>}  
                      {item.type==='refund'&& <td className="text-center py-2 px-4 border border-gray-300">#{item.orderCode}--[#{item.refundFromOrderNumber}]</td>}  
                     {item.type==='order'&& item.orderSalesManName &&<td className="text-center py-2 px-6 border border-gray-300"> مندوب المبيعات ({item.orderSalesManName})</td>}
                     {item.type==='order'&& item.orderSalesManName==='' &&<td className="text-center py-2 px-6 border border-gray-300">الصيدلية </td>}
                     {item.type==='refund'&& item.refundSalesManName &&<td className="text-center py-2 px-6 border border-gray-300"> مندوب المبيعات ({item.refundSalesManName})</td>}
                     {item.type==='refund'&& item.refundSalesManName==='' &&<td className="text-center py-2 px-6 border border-gray-300">الصيدلية </td>}
                        <td className="text-center py-2 px-6 border border-gray-300">{item.salesManName || 'لم يتم تعيين مندوب مبيعات لهذه العملية بعد'}</td>
                       {/* <td className="text-center py-2 px-6 border border-gray-300">{item.salesManEmail || 'لم يتم تعيين مندوب مبيعات لهذه العملية بعد'}</td>*/}
                     {/*   <td className="text-center py-2 px-6 border border-gray-300">
                          {item.paymentSource === 'شركة دواكو' ? 'شركة دواكو' : 'شركة مستحضرات التجميل'}
                        </td>*/} 
                        <td className="text-center py-2 px-6 border border-gray-300">{moment(item.createdAt).format('LLL')}</td>
                        <td className="text-center py-2 px-6 border border-gray-300">
                          {displayINRCurrency(item.totalPrice?.toString())}
                      </td>

                        <td className={`text-center py-2 px-6 border border-gray-300 ${getStatusColor(item.status)}`}>
                          {item.status === 'accepted' && 'تم تحضير الطلب وجاهز للتوصيل'}
                          {item.status === 'done' &&item.type==='order'&& ' تم ايصال الطلب بنجاح'} 
                          {item.status === 'done' &&item.type==='refund'&& ' طلب مرتجع مقبول'}
                          {item.status === 'rejected' && 'تم رفض الطلب'}
                          {item.status === 'pending' && 'جاري تحضير الطلب بالمخزن'}
                          {item.status === 'refused' && 'تم رفض الطلب'}
                          {item.status !== 'accepted' && item.status !== 'rejected' && item.status !== 'pending' && item.status !== 'done' &&item.status !== 'refused' && item.status}
                        </td>
                        <td className="text-center py-2 px-6 border border-gray-300">
                          <div className="flex items-center justify-center cursor-pointer" onClick={() => handleViewOrder(
                              item._id, 
                              item.paymentSource === 'شركة دواكو' ? 'Medicine' : 'Cosmetic'
                            )}>
                            <FaEye className="text-blue-600 mr-2" />
                            <span className="text-blue-600">اضغط هنا للتفاصيل</span>
                          </div>
                        </td>
                        
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </main>
    </div>
  );
};

export default OrderPage;
